import React, { useEffect, useState } from 'react'
import InvoicesHeader from 'component/Invoices/InvoicesHeader'
import InvoicesTable from 'component/Invoices/InvoicesTable'
import { useAppDispatch } from 'hooks/reduxHooks'
import { clearInvoice } from 'slices/invoice'

const InvoicesPageLAyout: React.FC = () => {
	const dispatch = useAppDispatch()

	const [isPaid, setIsPaid] = useState<boolean | undefined>(undefined)
	const onFilterChange = (val: string) => {
		if (val === 'yes') {
			setIsPaid(true)
		} else if (val === 'no') {
			setIsPaid(false)
		} else {
			setIsPaid(undefined)
		}
	}

	useEffect(() => {
		return () => {
			dispatch(clearInvoice())
		}
	}, [])

	return (
		<>
			<InvoicesHeader onFilterChange={onFilterChange} />
			<InvoicesTable isPaid={isPaid} />
		</>
	)
}

export default InvoicesPageLAyout
